import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import HeaderBackgroundAnimation from "./HeaderBackgroundAnimation";
import * as Utilities from "./AnimationUtilities";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    height: theme.sizes.headerHeight,
    minHeight: "300px",
    position: "relative",
    overflow: "hidden",
    backgroundColor: theme.palette.background.header,
  },
  headline: {
    [theme.breakpoints.only("xs")]: {
      fontSize: "38px",
    },
    [theme.breakpoints.only("sm")]: {
      fontSize: "44px",
    },
  },
  subHeadline: {
    [theme.breakpoints.only("xs")]: {
      marginTop: theme.spacing(1),
      fontSize: "22px",
    },
    [theme.breakpoints.only("sm")]: {
      marginTop: theme.spacing(1),
      fontSize: "28px",
    },
  },
  message: {
    position: "absolute",
    width: "100%",
    zIndex: 1000,
  },
}));

function AnimatedHeader(props) {
  const messageRef = React.useRef();

  useEffect(() => {
    // ELEMENTS
    const message = messageRef.current;
    Utilities.centerElement(message);
  }, []);

  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div ref={messageRef} className={classes.message}>
        <Typography className={classes.headline} variant="h2" align="center">
          Jonathan Harrison
        </Typography>
        <Typography className={classes.subHeadline} variant="h4" align="center">
          front end web development
        </Typography>
      </div>
      <HeaderBackgroundAnimation />
    </div>
  );
}

export default AnimatedHeader;
